"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
/**
 * Create component to work with Material UI link and react router dom
 * @param url - url to linkt o
 */
exports.RouterLink = function (url) { return function (props) { return (React.createElement(react_router_dom_1.Link, __assign({}, props, { to: url }))); }; };
